import React from 'react';
import { getYears } from '../../../../Helpers/DateFormat';

const ProductionFilters = props => {
  return (
    <div className='tc-filters-bg'>
      <div className='container'>
        <div className='row'>
          <form className='tc-filters' onSubmit={ev => props.click(ev)}>
            <div className='col'>
              <label htmlFor='filters-production-year'>Seleziona anno</label>
              <select
                id='filters-production-year'
                className='form-control'
                value={props.year}
                onChange={ev => props.changeYear(ev.target.value)}
              >
                {getYears().map(y => <option key={y} value={y}>{y}</option>)}
              </select>
            </div>
            <div className='col-auto'>
              <button className='btn btn-primary'>Filtra</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProductionFilters;
